import React from "react";
import { CheckCircle2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import useAuthStore from "@/store/use-auth-store";

interface OrderHeaderSectionProps {
  orderGroupId: string;
}

export const OrderHeaderSection: React.FC<OrderHeaderSectionProps> = ({
  orderGroupId,
}) => {
  const { t } = useTranslation();
  const { user } = useAuthStore();

  // Get user name from first order or auth store
  const userName = user?.name || "User";

  const userEmail = user?.email || "";

  return (
    <div className="flex flex-col items-center gap-3 md:gap-4 py-6 md:py-8">
      {/* Success Icon */}
      <div className="relative w-[48px] h-[48px] md:w-[54px] md:h-[54px]">
        <CheckCircle2 className="w-full h-full text-[#17b26a]" />
      </div>

      {/* Thank You Message */}
      <h1 className="text-xl md:text-2xl lg:text-3xl font-semibold text-text-primary dark:text-text-primary text-center px-4">
        {t("orders.thankYou", { name: userName })}
      </h1>

      {/* Order Number */}
      <p className="text-xs md:text-sm text-text-tertiary dark:text-text-tertiary text-center px-4">
        <span>{t("orders.orderNumber")} </span>
        <span className="font-semibold text-text-secondary dark:text-text-secondary underline">
          #{orderGroupId}
        </span>
      </p>

      {/* Email Confirmation Message */}
      {userEmail && (
        <p className="text-xs md:text-sm text-text-tertiary dark:text-text-tertiary text-center max-w-2xl px-4">
          <span>{t("orders.emailSentPrefix")} </span>
          <span className="font-semibold text-text-secondary dark:text-text-secondary">
            {userEmail}
          </span>
          <span> {t("orders.emailSentSuffix")}</span>
        </p>
      )}
    </div>
  );
};
